import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';


const useStyles = makeStyles({
  root: {
    maxWidth: 600,
    minWidth: 600,
    marginBottom: 30,


  },
  media: {
     height: 400,
     
  },
});

function ProjectCard({ item }) {
  const classes = useStyles();
  const { name, img, desc, link, subtitle } = item;
  return (
    <Link href={link} ocolor="inherit">
      <Card className={classes.root}>
        <CardActionArea>
          <CardMedia
            className={classes.media}
            image={img}
            title={name}
            href="#contained-buttons"
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="h5">

              {name}
            </Typography>
            <Typography variant="h6" color="textSecondary" component="p">
              {subtitle}
            </Typography>
            <Typography variant="body1" color="textSecondary" component="p">
              {desc}
            </Typography>
            <span>Нажмите, чтобы посмотреть Демо</span>
          </CardContent>
        </CardActionArea>

      </Card>

    </Link>
  );
}



export default ProjectCard